var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJmaLogoRgbMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 1345",
    style: {
      enableBackground: "new 0 0 2500 1345"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A2240;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000067233107197170320870000017353984732359527045_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,1075.23C0,1236.86,101.6,1345,292.19,1345l0,0c192.69,0,303.37-113.31,303.37-276.01 c0-103.62,0-658.54,0-658.54H381.18c0,0,0,570.43,0,642.86c0,58.73-29.29,100.03-88.99,100.03c-55.68,0-90.03-34.93-90.03-98.28 V952.67H0V1075.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1158.47,841.42 1018.72,410.43 713.92,410.43 713.92,1331.9 926.85,1331.9 926.85,706.68  1065.69,1129.32 1251.25,1129.32 1390.09,706.68 1390.09,1331.9 1603.02,1331.9 1603.02,410.43 1298.21,410.43  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2265.27,1331.91h229.17l-258-921.48h-293.75l-258,921.48h229.17l52.74-201.87h245.93L2265.27,1331.91z  M2014.1,948.22l75.46-288.82h0l75.46,288.82H2014.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2089.6619,
    y1: 820.8577,
    x2: 2089.6619,
    y2: 0.000001472379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#A7C6E0",
      stopOpacity: 0.287
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5428,
    style: {
      stopColor: "#5F98C7",
      stopOpacity: 0.5428
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    style: {
      stopColor: "#2C76B5",
      stopOpacity: 0.7539
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#0C62AA",
      stopOpacity: 0.9123
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005AA6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2089.66,184.93c-124.51,0-225.45,100.96-225.45,225.5c0,48.78,15.53,93.89,41.85,130.79l36.62-130.79 c0-81.19,65.8-147.01,146.98-147.01c81.17,0,146.98,65.82,146.98,147.01c0,0.21-0.03,0.42-0.03,0.64l36.5,130.36 c26.41-36.93,42-82.13,42-131C2315.11,285.89,2214.18,184.93,2089.66,184.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054984003399145830830000004276226691215063181_",
    gradientUnits: "userSpaceOnUse",
    x1: 2089.6619,
    y1: 820.8577,
    x2: 2089.6619,
    y2: 0.000001472437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#A7C6E0",
      stopOpacity: 0.287
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5428,
    style: {
      stopColor: "#5F98C7",
      stopOpacity: 0.5428
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    style: {
      stopColor: "#2C76B5",
      stopOpacity: 0.7539
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    style: {
      stopColor: "#0C62AA",
      stopOpacity: 0.9123
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005AA6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054984003399145830830000004276226691215063181_)"
    },
    d: "M1767.39,410.43 c0-178.03,144.29-322.34,322.27-322.34c177.99,0,322.28,144.32,322.28,322.34c0,95.77-41.8,181.73-108.09,240.77l25.77,92.06 C2432.8,668.72,2500,547.46,2500,410.43C2500,183.76,2316.28,0,2089.66,0c-226.62,0-410.34,183.76-410.34,410.43 c0,136.96,67.13,258.16,170.2,332.71l25.78-92.08C1809.11,592.02,1767.39,506.12,1767.39,410.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmaLogoRgbMaster);
export default __webpack_public_path__ + "static/media/JMA_Logo_RGB_MASTER.da45b7ca4a63c9352f078be4ed886052.svg";
export { ForwardRef as ReactComponent };